import { createFileRoute, redirect } from "@tanstack/react-router"
import { OrganizationProfilePage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const VALID_TABS = [
  "profile",
  "logo-branding",
  "social-media",
  "public-settings",
] as const

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/organization-profile/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (!VALID_TABS.includes(params.tabKey as (typeof VALID_TABS)[number])) {
      throw redirect({
        to: "/organization-settings/organization-profile/$tabKey",
        params: { tabKey: "profile" },
      })
    }
  },
  component: () => (
    <AuthorizationGate resource={Resource.ORGANIZATION} action={Action.READ}>
      <OrganizationProfilePage />
    </AuthorizationGate>
  ),
})
